const styles = {
  dropdown: {
    minWidth: "200px",
  },

  disabled: {
    opacity: 0.5,
    pointerEvents: "none",
  },

  leftSideBtn: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    borderRadius: "8px 8px 8px 8px",
    fontWeight: "600",
    height: "38px",
    fontSize: "12px",
    lineHeight: "24px",
    padding: "6px 8px",
    "&:hover": {
      color: "#00ADF8",
      border: `1px solid #00ADF8`,
    },
  },
};

export default styles;
